<template>
  <van-popup v-model="show" round position="bottom" :style="{ height: '85%' }" get-container="#app" lock-scroll>
    <div class="popup-div" @touchmove.stop>
      <div class="tetle">
        <span>选择模版</span>
        <img src="@/assets/close.png" alt class="close_img" @click="closeCodeModal"/>
      </div>
      <div class="full-comment">
        <div class="" style="height:100%">
          <div class="tips">
            <div class="tips-tetel-one">活动文案模板将控制用户在查看参与本期活动的商品详情、活动商品列表时对应的文案显示，请选择其中一项</div>
          </div>
          <div class="data" scroll-y="scroll">
            <!--  -->
            <div class="data-line"  :class="item.id === configId ? 'select_config':'no_select_config'"  v-for="item,index in discountActivityList" :key="index"  @click.stop="onRadioType(index)" >
              <div class="coment_view">
                <div class="title">{{ item.templateName }}</div>
                <div class="content">{{item.remark}}</div>
              </div>
              <div class="icon">
                <img :src="item.id === configId ? $theme.assist_icon_radio_default : $theme.assist_icon_radio_default_unselect" mode="widthFix"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="full-btn">
        <div class="sumbtn"  @click="onSbmit()">确定</div>
      </div>
     
    </div>
  </van-popup>
</template>

<script>
const CHECK = {
    uncheck: 1,   // 未选中 
    checked: 2,   // 选中
    // disabled: 3   //  置灰不可选 
}
import { Toast } from "vant";
import Util from "@/utils/common";
import http from "@/utils/axios";
export default {
  name: "",
  props: {},
  data(){
    return{
      show:false,
      discountActivityList:[],
      configId:'',
      obj:{}
    };
  },
  methods:{
    closeCodeModal(){
      this.show = !this.show;
    },
    getShow(discountActivityList,configId){
      this.discountActivityList = discountActivityList
      this.configId =  configId
      this.obj=discountActivityList.find(item=>{
        return item.id == configId
      })
      this.show = !this.show;
    },
    // 点击选中
    onRadioType(index){
      let discountActivityList =JSON.parse(JSON.stringify(this.discountActivityList)) ;
      let configId = discountActivityList[index].id;
      console.log('configId',configId,this.configId)
      if(configId == this.configId) return
      this.configId = configId
      this.obj = discountActivityList[index];
    },
    onSbmit(){
      if(this.configId == ""){
        return this.$toast("请选择模板!");
      }else{
        console.log('this.obj',this.obj)
        this.$emit('event-discount', this.obj);
        this.show = false;
      }
    }
  }
}
</script>

<style scoped lang="less">
.popup-div{
  height: 100%;
  position: relative;
  .tetle{
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    font-size:36px;
    font-weight: 600;
    color:#3B3A38;
    text-align: center;
    padding: 38px 0;
    .close_img {
      width: 60px;
      height: 60px;
      object-fit: cover;
      position: absolute;
      top: 20px;
      right: 20px;
    }
  }
  .full-comment{
    padding: 100px 24px 10px;
    height: calc(100% - 240px);

    .tips{
      background: #FEF6F0;
      border-radius: 20px;
      padding: 24px;
      .tips-tetel{
        font-weight: 500;
        color: #F08E3C;
        font-size: 26px;
      }
      .tips-tetel-one{
        color: #F08E3C;
        font-size: 24px;
        line-height: 35px;
      }
    }
    .select{
      color:#3B3A38;
      font-size: 28px;
      padding: 24px 0 0;
    }
  }
  .full-btn{
    display: flex;
    width: 100%;
    position: absolute;
    bottom: 30px;
    left: 0;
    align-items: center;
    justify-content: center;
    margin-top: 27px;
    div{
      width:340px;
      height: 80px;
      line-height: 80px;
      text-align: center;
      border-radius: 40px;
      font-size: 32px;
    }
    .sumbtn{
      width: 80%;
      background: var(--epButtonColor);
      border-color: var(--epButtonColor);
      color: var(--epTextColor);
    }
  }
}


.data{
  height: calc(100% - 180px);
  overflow: auto;
  padding: 0px 0px 24px;
}
::v-deep .select_config{
  background: rgba(255,209,2,0.2);
  border-radius: 8px;
  border: 1px solid #FFC601;
}
.no_select_config{
  background: #FFFFFF;
  border: 1px solid #E1E1E1;
}

.data-line{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding:24px 16px;
  border-radius: 16px;
 
  margin-top: 16px;
 
  .icon {
    width: 48px;
    height: 48px;
    display: contents;
    img{
      width: 48px;
      height: 48px;
    }
  }
  .coment_view{
    color: #3B3A38;
    .title{
      font-weight: 600;
      font-size: 28px;
      margin-bottom: 8px;
    }
    .content{
      font-size: 26px;
    }
  }
  
  .boxNoSelect{
    border: 1px solid #fff;
  }
  .boxSelect{
   border: 1px solid #FFD102;
  }

}


</style>